import { render, staticRenderFns } from "./ShippingUnitsSummary.vue?vue&type=template&id=b58dbb2a&scoped=true"
import script from "./ShippingUnitsSummary.vue?vue&type=script&lang=js"
export * from "./ShippingUnitsSummary.vue?vue&type=script&lang=js"
import style0 from "./ShippingUnitsSummary.vue?vue&type=style&index=0&id=b58dbb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58dbb2a",
  null
  
)

export default component.exports